// source: feature_proto.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var timestamp_proto_pb = require('./timestamp_proto_pb.js');
goog.object.extend(proto, timestamp_proto_pb);
goog.exportSymbol('proto.Capability', null, global);
goog.exportSymbol('proto.Capability.Status', null, global);
goog.exportSymbol('proto.Capability.Visibility', null, global);
goog.exportSymbol('proto.FeatureInfo', null, global);
goog.exportSymbol('proto.FeatureInfo.FeatureName', null, global);
goog.exportSymbol('proto.FeatureInfo.FeatureNameCase', null, global);
goog.exportSymbol('proto.FeatureInfo.TreatmentCase', null, global);
goog.exportSymbol('proto.IdentityCapability', null, global);
goog.exportSymbol('proto.OrganizationCapability', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.FeatureInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.FeatureInfo.oneofGroups_);
};
goog.inherits(proto.FeatureInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.FeatureInfo.displayName = 'proto.FeatureInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Capability = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Capability.repeatedFields_, null);
};
goog.inherits(proto.Capability, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Capability.displayName = 'proto.Capability';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.OrganizationCapability = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.OrganizationCapability, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.OrganizationCapability.displayName = 'proto.OrganizationCapability';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.IdentityCapability = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IdentityCapability, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.IdentityCapability.displayName = 'proto.IdentityCapability';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.FeatureInfo.oneofGroups_ = [[1],[2]];

/**
 * @enum {number}
 */
proto.FeatureInfo.FeatureNameCase = {
  FEATURE_NAME_NOT_SET: 0,
  NAME: 1
};

/**
 * @return {proto.FeatureInfo.FeatureNameCase}
 */
proto.FeatureInfo.prototype.getFeatureNameCase = function() {
  return /** @type {proto.FeatureInfo.FeatureNameCase} */(jspb.Message.computeOneofCase(this, proto.FeatureInfo.oneofGroups_[0]));
};

/**
 * @enum {number}
 */
proto.FeatureInfo.TreatmentCase = {
  TREATMENT_NOT_SET: 0,
  TREATMENTBOOLEAN: 2
};

/**
 * @return {proto.FeatureInfo.TreatmentCase}
 */
proto.FeatureInfo.prototype.getTreatmentCase = function() {
  return /** @type {proto.FeatureInfo.TreatmentCase} */(jspb.Message.computeOneofCase(this, proto.FeatureInfo.oneofGroups_[1]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.FeatureInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.FeatureInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.FeatureInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.FeatureInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
name: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
treatmentboolean: (f = jspb.Message.getBooleanField(msg, 2)) == null ? undefined : f,
nameText: jspb.Message.getFieldWithDefault(msg, 3, ""),
displayName: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.FeatureInfo}
 */
proto.FeatureInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.FeatureInfo;
  return proto.FeatureInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.FeatureInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.FeatureInfo}
 */
proto.FeatureInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.FeatureInfo.FeatureName} */ (reader.readEnum());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTreatmentboolean(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNameText(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.FeatureInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.FeatureInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.FeatureInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.FeatureInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!proto.FeatureInfo.FeatureName} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getNameText();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.FeatureInfo.FeatureName = {
  NONE: 0,
  MEDIAOVERSAT: 1,
  SOSSANDBOX: 2,
  AUTODEVICEIDENTITY: 3,
  INTERNAL: 4,
  RADIO: 5,
  MOBILEUSB: 6,
  FILTERTRACKINGHISTORY: 7,
  MOBILECELLTRACKING: 8,
  ORGANIZATIONINTERNALSOS: 9,
  MOBILEUSBPROD: 10,
  WEB_DIYORGANIZATION: 11,
  WEB_ORGANIZATIONREMOVEMEMBER: 12,
  WEB_ORGANIZATIONREMOVEWORKSPACE: 13,
  WEB_TAKSERVER: 14,
  WEB_WAYPOINTSYMBOLS: 15,
  WEB_WORKSPACEREMOVEMEMBER: 16,
  STEALTHPROFILE: 17,
  WEB_CREATESHAPE: 18,
  WEB_MAPTOOLBAR: 19,
  WEB_MAPWORKSPACEMESSAGES: 20,
  NFC: 21,
  MOBILEFIRMWAREDEBUGGING: 22,
  ORGPASSWORDRESET: 23,
  ALLOWANDROIDPROXY: 24,
  WEB_ENABLEBACKHAULOTASETTING: 25,
  WEB_ENABLESELFSERVEAPIKEYS: 26,
  DATADOGALLOWED: 27,
  WEB_FEDERATEDTAKSERVER: 28
};

/**
 * optional FeatureName name = 1;
 * @return {!proto.FeatureInfo.FeatureName}
 */
proto.FeatureInfo.prototype.getName = function() {
  return /** @type {!proto.FeatureInfo.FeatureName} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.FeatureInfo.FeatureName} value
 * @return {!proto.FeatureInfo} returns this
 */
proto.FeatureInfo.prototype.setName = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.FeatureInfo.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.FeatureInfo} returns this
 */
proto.FeatureInfo.prototype.clearName = function() {
  return jspb.Message.setOneofField(this, 1, proto.FeatureInfo.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.FeatureInfo.prototype.hasName = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool treatmentBoolean = 2;
 * @return {boolean}
 */
proto.FeatureInfo.prototype.getTreatmentboolean = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.FeatureInfo} returns this
 */
proto.FeatureInfo.prototype.setTreatmentboolean = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.FeatureInfo.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.FeatureInfo} returns this
 */
proto.FeatureInfo.prototype.clearTreatmentboolean = function() {
  return jspb.Message.setOneofField(this, 2, proto.FeatureInfo.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.FeatureInfo.prototype.hasTreatmentboolean = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string name_text = 3;
 * @return {string}
 */
proto.FeatureInfo.prototype.getNameText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.FeatureInfo} returns this
 */
proto.FeatureInfo.prototype.setNameText = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string display_name = 4;
 * @return {string}
 */
proto.FeatureInfo.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.FeatureInfo} returns this
 */
proto.FeatureInfo.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Capability.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Capability.prototype.toObject = function(opt_includeInstance) {
  return proto.Capability.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Capability} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Capability.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
description: jspb.Message.getFieldWithDefault(msg, 2, ""),
displayName: jspb.Message.getFieldWithDefault(msg, 3, ""),
path: jspb.Message.getFieldWithDefault(msg, 4, ""),
visibility: jspb.Message.getFieldWithDefault(msg, 5, 0),
status: jspb.Message.getFieldWithDefault(msg, 6, 0),
tagsList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
lastUpdated: (f = msg.getLastUpdated()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f),
owner: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Capability}
 */
proto.Capability.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Capability;
  return proto.Capability.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Capability} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Capability}
 */
proto.Capability.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    case 5:
      var value = /** @type {!proto.Capability.Visibility} */ (reader.readEnum());
      msg.setVisibility(value);
      break;
    case 6:
      var value = /** @type {!proto.Capability.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addTags(value);
      break;
    case 8:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastUpdated(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwner(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Capability.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Capability.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Capability} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Capability.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getVisibility();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
  f = message.getLastUpdated();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getOwner();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.Capability.Visibility = {
  VISIBILITYNONE: 0,
  VISIBILITYHIDDEN: 1,
  VISIBILITYINTERNAL: 2,
  VISIBILITYPRIVATE: 3,
  VISIBILITYPUBLIC: 4
};

/**
 * @enum {number}
 */
proto.Capability.Status = {
  STATUSNONE: 0,
  STATUSDEVELOPMENT: 1,
  STATUSINTERNAL: 2,
  STATUSBETA: 3,
  STATUSRAMPING: 4,
  STATUSRELEASED: 5,
  STATUSREMOVED: 6
};

/**
 * optional string name = 1;
 * @return {string}
 */
proto.Capability.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Capability} returns this
 */
proto.Capability.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.Capability.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Capability} returns this
 */
proto.Capability.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string display_name = 3;
 * @return {string}
 */
proto.Capability.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Capability} returns this
 */
proto.Capability.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string path = 4;
 * @return {string}
 */
proto.Capability.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.Capability} returns this
 */
proto.Capability.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional Visibility visibility = 5;
 * @return {!proto.Capability.Visibility}
 */
proto.Capability.prototype.getVisibility = function() {
  return /** @type {!proto.Capability.Visibility} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.Capability.Visibility} value
 * @return {!proto.Capability} returns this
 */
proto.Capability.prototype.setVisibility = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional Status status = 6;
 * @return {!proto.Capability.Status}
 */
proto.Capability.prototype.getStatus = function() {
  return /** @type {!proto.Capability.Status} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.Capability.Status} value
 * @return {!proto.Capability} returns this
 */
proto.Capability.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * repeated string tags = 7;
 * @return {!Array<string>}
 */
proto.Capability.prototype.getTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.Capability} returns this
 */
proto.Capability.prototype.setTagsList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.Capability} returns this
 */
proto.Capability.prototype.addTags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Capability} returns this
 */
proto.Capability.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};


/**
 * optional Timestamp last_updated = 8;
 * @return {?proto.Timestamp}
 */
proto.Capability.prototype.getLastUpdated = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 8));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.Capability} returns this
*/
proto.Capability.prototype.setLastUpdated = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Capability} returns this
 */
proto.Capability.prototype.clearLastUpdated = function() {
  return this.setLastUpdated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Capability.prototype.hasLastUpdated = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string owner = 9;
 * @return {string}
 */
proto.Capability.prototype.getOwner = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.Capability} returns this
 */
proto.Capability.prototype.setOwner = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.OrganizationCapability.prototype.toObject = function(opt_includeInstance) {
  return proto.OrganizationCapability.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.OrganizationCapability} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.OrganizationCapability.toObject = function(includeInstance, msg) {
  var f, obj = {
capability: (f = msg.getCapability()) && proto.Capability.toObject(includeInstance, f),
organizationId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.OrganizationCapability}
 */
proto.OrganizationCapability.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.OrganizationCapability;
  return proto.OrganizationCapability.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.OrganizationCapability} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.OrganizationCapability}
 */
proto.OrganizationCapability.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.Capability;
      reader.readMessage(value,proto.Capability.deserializeBinaryFromReader);
      msg.setCapability(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.OrganizationCapability.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.OrganizationCapability.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.OrganizationCapability} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.OrganizationCapability.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCapability();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.Capability.serializeBinaryToWriter
    );
  }
  f = message.getOrganizationId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional Capability capability = 1;
 * @return {?proto.Capability}
 */
proto.OrganizationCapability.prototype.getCapability = function() {
  return /** @type{?proto.Capability} */ (
    jspb.Message.getWrapperField(this, proto.Capability, 1));
};


/**
 * @param {?proto.Capability|undefined} value
 * @return {!proto.OrganizationCapability} returns this
*/
proto.OrganizationCapability.prototype.setCapability = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.OrganizationCapability} returns this
 */
proto.OrganizationCapability.prototype.clearCapability = function() {
  return this.setCapability(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.OrganizationCapability.prototype.hasCapability = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string organization_id = 2;
 * @return {string}
 */
proto.OrganizationCapability.prototype.getOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.OrganizationCapability} returns this
 */
proto.OrganizationCapability.prototype.setOrganizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.IdentityCapability.prototype.toObject = function(opt_includeInstance) {
  return proto.IdentityCapability.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IdentityCapability} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.IdentityCapability.toObject = function(includeInstance, msg) {
  var f, obj = {
capability: (f = msg.getCapability()) && proto.Capability.toObject(includeInstance, f),
identityId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IdentityCapability}
 */
proto.IdentityCapability.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.IdentityCapability;
  return proto.IdentityCapability.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IdentityCapability} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IdentityCapability}
 */
proto.IdentityCapability.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.Capability;
      reader.readMessage(value,proto.Capability.deserializeBinaryFromReader);
      msg.setCapability(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentityId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.IdentityCapability.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.IdentityCapability.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IdentityCapability} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.IdentityCapability.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCapability();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.Capability.serializeBinaryToWriter
    );
  }
  f = message.getIdentityId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional Capability capability = 1;
 * @return {?proto.Capability}
 */
proto.IdentityCapability.prototype.getCapability = function() {
  return /** @type{?proto.Capability} */ (
    jspb.Message.getWrapperField(this, proto.Capability, 1));
};


/**
 * @param {?proto.Capability|undefined} value
 * @return {!proto.IdentityCapability} returns this
*/
proto.IdentityCapability.prototype.setCapability = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.IdentityCapability} returns this
 */
proto.IdentityCapability.prototype.clearCapability = function() {
  return this.setCapability(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.IdentityCapability.prototype.hasCapability = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string identity_id = 3;
 * @return {string}
 */
proto.IdentityCapability.prototype.getIdentityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.IdentityCapability} returns this
 */
proto.IdentityCapability.prototype.setIdentityId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


goog.object.extend(exports, proto);
